import React from 'react';

function FashionT() {
  return <div></div>;
}

export default FashionT;
